export const GooglePlayIcon = () => (
  <svg
    width="22"
    height="25"
    viewBox="0 0 22 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.3881 11.963L0.320488 22.5108C0.433534 22.9115 0.636695 23.281 0.914439 23.5911C1.19218 23.9012 1.53716 24.1437 1.92299 24.3001C2.30882 24.4564 2.7253 24.5225 3.14058 24.4932C3.55586 24.464 3.95895 24.3401 4.31904 24.1312L15.647 17.6795L10.3881 11.963Z"
      fill="#EA4335"
    />
    <path
      d="M20.5683 10.1701L15.6695 7.36432L10.1556 12.2031L15.692 17.6645L20.5533 14.8888C20.984 14.6633 21.3447 14.3242 21.5964 13.9083C21.8481 13.4924 21.9812 13.0156 21.9812 12.5294C21.9812 12.0433 21.8481 11.5664 21.5964 11.1505C21.3447 10.7346 20.984 10.3955 20.5533 10.1701H20.5683Z"
      fill="#FBBC04"
    />
    <path
      d="M0.320499 2.49554C0.259642 2.72052 0.229362 2.95267 0.230475 3.18573V21.8206C0.231084 22.0536 0.261335 22.2855 0.320499 22.5108L10.7332 12.2331L0.320499 2.49554Z"
      fill="#4285F4"
    />
    <path
      d="M10.4632 12.5032L15.6695 7.36431L4.35655 0.882606C3.93095 0.633346 3.4469 0.501331 2.95368 0.500005C2.35801 0.498825 1.77829 0.692452 1.30289 1.05137C0.827495 1.41029 0.482497 1.91481 0.320488 2.48803L10.4632 12.5032Z"
      fill="#34A853"
    />
  </svg>
);
